$('#search-menu').click(() => {
    $.getScript(app.google.searchEngine).done(() => {
        return notify.fire({
            title: 'Recherche',
            html: `<div class="gcse-search"></div>`,
            showCloseButton: true,
            showConfirmButton: false,
            showCancelButton: false
        });
    });

});